import React from 'react';
import { PublishedPost } from '../hooks/usePublishedPosts';
import { platforms } from '../config/platforms';
import { PlatformIcon } from './PlatformIcon';
import { PostCard } from './PostCard';
import './LinkedPostBar.css';

interface LinkedPostBarProps {
  post: PublishedPost;
  mode: 'reply' | 'quote';
  onToggleMode: () => void;
  onClear: () => void;
}

export const LinkedPostBar: React.FC<LinkedPostBarProps> = ({
  post,
  mode,
  onToggleMode,
  onClear,
}) => {
  return (
    <div className="linked-post-bar">
      <div className="linked-post-header">
        <div className="linked-post-header-chips">
        <button
          className="linked-post-mode-toggle"
          onClick={onToggleMode}
          title="Click to toggle between Reply and Quote"
        >
          {mode === 'reply' ? (
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <polyline points="9 14 4 9 9 4"></polyline>
              <path d="M20 20v-7a4 4 0 0 0-4-4H4"></path>
            </svg>
          ) : (
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"></path>
            </svg>
          )}
          <span className="linked-post-mode-label">
            {mode === 'reply' ? 'Replying to' : 'Quoting'}
          </span>
        </button>
          <div className="linked-post-platforms-chip">
            {post.twitter && (
              <a
                href={post.twitter.url}
                target="_blank"
                rel="noopener noreferrer"
                title="View on X/Twitter"
                className="linked-post-platform-link"
              >
                <PlatformIcon platformKey="twitter" icon={platforms.twitter.icon} size={16} className="linked-post-platform-icon" />
              </a>
            )}
            {post.bluesky && (
              <a
                href={post.bluesky.url}
                target="_blank"
                rel="noopener noreferrer"
                title="View on Bluesky"
                className="linked-post-platform-link"
              >
                <PlatformIcon platformKey="bluesky" icon={platforms.bluesky.icon} size={16} className="linked-post-platform-icon" />
              </a>
            )}
            {post.farcaster && (
              <a
                href={post.farcaster.url}
                target="_blank"
                rel="noopener noreferrer"
                title="View on Farcaster"
                className="linked-post-platform-link"
              >
                <PlatformIcon platformKey="farcaster" icon={platforms.farcaster.icon} size={16} className="linked-post-platform-icon" />
              </a>
            )}
          </div>
        </div>
        <button
          className="linked-post-clear"
          onClick={onClear}
          title="Remove"
        >
          Remove
        </button>
      </div>
      <PostCard post={post} variant="compact" />
    </div>
  );
};
